import React from "react";
import { Typography } from "antd";

type HeaderProps = {
  topic: string;
  logoSrc: string;
};

const Header: React.FC<HeaderProps> = ({ topic, logoSrc }) => {
  const { Title } = Typography;

  return (
    <div className="flex items-center gap-2 md:gap-3">
      <img
        src={logoSrc}
        alt="logo"
        className="h-7 w-7 md:h-10 md:w-10 object-contain select-none block"
        draggable={false}
      />

      <Title
        level={1}
        className="!m-0 !leading-none !text-[22px] md:!text-[34px]"
      >
        <span className="bg-gradient-to-b from-white to-[#bfc7d5] bg-clip-text text-transparent">
          {topic}
        </span>
      </Title>
    </div>
  );
};

export default Header;